<template>
  <div class='navContainer'>
    <b-nav vertical class="mailboxNav">
      <b-nav-item class="active">
        <h4>{{currentInbox.name}}</h4>
        <h5 v-if="subfolderName">{{subfolderName}}</h5>
      </b-nav-item>
      <b-nav-item :class="isActive('inbox')" @click="filterInbox('inbox')">
        <span class='menu-left'><fa icon="envelope-open"/>  Unassigned</span>
        <span class='menu-right'>{{currentInbox.totalActive || 0}}</span>
      </b-nav-item>
      <b-nav-item  :class="isActive('mine')" @click="filterInbox('mine')">
        <span class='menu-left'><fa icon="user-check"/>  Mine</span>
        <span class='menu-right'>{{currentInbox.totalMine || 0}}</span>
      </b-nav-item>
      <b-nav-item :class="isActive('assigned')" @click="filterInbox('assigned')">
        <span class='menu-left'><fa icon="user"/>  Assigned</span>
        <span class='menu-right'>{{currentInbox.totalAssigned || 0}}</span>
      </b-nav-item>
      <b-nav-item :class="isActive('drafts')" @click="filterInbox('drafts')">
        <span class='menu-left'><fa icon="pen"/>  Drafts</span>
        <span class='menu-right'>{{currentInbox.totalDrafts || 0}}</span>
      </b-nav-item>
      <b-nav-item :class="isActive('closed')" @click="filterInbox('closed')">
        <span class='menu-left'><fa icon="trash-alt"/>  Closed</span>
        <span class='menu-right'></span>
      </b-nav-item>
      <b-nav-item class="active" @click="showNewMessageModal(currentInbox)">
        <span class='menu-left'><fa icon="plus-circle"/>  Compose</span>
        <span class='menu-right'></span>
      </b-nav-item>
    </b-nav>
    <b-nav vertical class="mailboxNav">
    </b-nav>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NavMailbox',
  props: ['subfolder'],
  data () {
    return {
      active: 'inbox'
    }
  },
  computed: {
    ...mapGetters(['currentInbox']),
    subfolderName () {
      if (this.subfolder && this.currentInbox && this.currentInbox.subfolders) {
        let sub = this.currentInbox.subfolders.find((sub) => { return sub.id === this.subfolder })
        if (sub) {
          return sub.name
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  methods: {
    isActive (folder) {
      return this.active === folder ? 'active' : 'inactive'
    },
    filterInbox (folder) {
      if (this.$route.name === 'Inbox') {
        this.active = folder
        this.$root.$emit('filterInbox', folder)
      } else {
        this.$router.push({path: '/inboxes/' + this.currentInbox.id, query: {q: folder}})
      }
    },
    showNewMessageModal (mailbox) {
      this.$root.$emit('composeMessage', mailbox)
    }
  }
}
</script>
<style scoped>
  .inactive a {
    color: #e0e0e0;
  }
  .active a {
    color: #fff5f5;
  }
  .menu-left {
    padding: 5px;
    display: block;
    float: left;
  }
  .menu-right {
    padding: 5px;
    display: block;
    float: right;
  }
  .navContainer {
    margin: 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavMailbox.vue